
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class DocumentStoreGrid extends SiteEntityGrid<DocumentStoreRow, any> {
        protected getColumnsKey() { return 'Data.DocumentStore'; }
        protected getDialogType() { return DocumentStoreDialog; }
        protected getIdProperty() { return DocumentStoreRow.idProperty; }
        protected getLocalTextPrefix() { return DocumentStoreRow.localTextPrefix; }
        protected getService() { return DocumentStoreService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}